"use client";

import { m as motion, useReducedMotion } from "framer-motion";

/**
 * Micro-glyph animati per le card "Cosa sto costruendo" di /chi-sono.
 * Solo transform/opacity (composite). reduced-motion => statici.
 * Decorativi: aria-hidden.
 */

const STROKE = "hsl(var(--primary))";

/** Grafo neurale stile "company brain": nodi che pulsano, link statici. */
export function NodeGraphGlyph() {
  const reduce = useReducedMotion();
  const nodes = [
    { cx: 32, cy: 32, r: 5, core: true },
    { cx: 13, cy: 17, r: 3 },
    { cx: 51, cy: 14, r: 3 },
    { cx: 53, cy: 46, r: 3 },
    { cx: 15, cy: 50, r: 3 },
    { cx: 34, cy: 9, r: 2.4 },
  ];
  return (
    <svg viewBox="0 0 64 64" className="h-full w-full" aria-hidden>
      <g stroke={STROKE} strokeWidth={1} opacity={0.45} fill="none">
        {nodes.slice(1).map((n, i) => (
          <line key={i} x1={32} y1={32} x2={n.cx} y2={n.cy} />
        ))}
        <line x1={13} y1={17} x2={34} y2={9} />
        <line x1={51} y1={14} x2={53} y2={46} />
      </g>
      <g fill={STROKE}>
        {nodes.map((n, i) => (
          <motion.circle
            key={i}
            cx={n.cx}
            cy={n.cy}
            r={n.r}
            opacity={n.core ? 1 : 0.7}
            animate={
              reduce
                ? undefined
                : { opacity: n.core ? [1, 0.7, 1] : [0.35, 0.9, 0.35] }
            }
            transition={
              reduce
                ? undefined
                : {
                    duration: 2.6,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: i * 0.25,
                  }
            }
          />
        ))}
      </g>
    </svg>
  );
}

/** Radar/scansione "farsi trovare": anelli + sweep che ruota + blip che pulsano. */
export function RadarGlyph() {
  const reduce = useReducedMotion();
  return (
    <div className="relative h-full w-full">
      <motion.div
        className="absolute inset-0"
        style={{ transformOrigin: "center" }}
        animate={reduce ? undefined : { rotate: 360 }}
        transition={
          reduce
            ? undefined
            : { duration: 4.5, repeat: Infinity, ease: "linear" }
        }
      >
        <svg viewBox="0 0 64 64" className="h-full w-full" aria-hidden>
          <g stroke={STROKE} fill="none">
            <circle cx={32} cy={32} r={26} opacity={0.25} />
            <circle cx={32} cy={32} r={17} opacity={0.3} />
            <circle cx={32} cy={32} r={8} opacity={0.4} />
          </g>
          {/* sweep: settore + linea */}
          <path
            d="M32 32 L32 6 A26 26 0 0 1 54 20 Z"
            fill={STROKE}
            opacity={0.14}
          />
          <line
            x1={32}
            y1={32}
            x2={32}
            y2={6}
            stroke={STROKE}
            strokeWidth={1.3}
            opacity={0.8}
          />
        </svg>
      </motion.div>
      <svg
        viewBox="0 0 64 64"
        className="absolute inset-0 h-full w-full"
        aria-hidden
      >
        <g fill={STROKE}>
          {[
            { cx: 44, cy: 22 },
            { cx: 22, cy: 42 },
          ].map((b, i) => (
            <motion.circle
              key={i}
              cx={b.cx}
              cy={b.cy}
              r={2.4}
              animate={reduce ? undefined : { opacity: [0.2, 1, 0.2] }}
              transition={
                reduce
                  ? undefined
                  : {
                      duration: 4.5,
                      repeat: Infinity,
                      ease: "easeInOut",
                      delay: i * 1.6,
                    }
              }
            />
          ))}
        </g>
      </svg>
    </div>
  );
}
